<template>
  <main class="min-h-screen pb-24 pt-16">
    <NuxtImg
      format="auto"
      src="https://origin-cdn.o7n.co/web/tester-club/banner-mobile-3.png"
      alt=""
      class="w-full md:hidden"
      sizes="xs:100vw sm:100vw" />
    <NuxtImg
      format="auto"
      src="https://origin-cdn.o7n.co/web/tester-club/banner-desktop-4.png"
      alt=""
      class="mx-auto w-full max-w-6xl max-md:hidden"
      sizes="md:100vw lg:100vw xl:100vw xxl:100vw" />
    <Container class="text-center text-white">
      <h1 class="mx-auto max-w-xl pb-16 pt-24 text-4xl leading-tight md:text-5xl">Outfit7 Tester Club</h1>
      <p class="mx-auto max-w-xl pb-6">
        {{ $t('intro1') }}
        <br />
        <br />
        {{ $t('intro2') }}
        <br />
        <br />
        {{ $t('intro3') }}
        <br />
        <br />
        {{ $t('intro4') }}
      </p>
    </Container>
    <ApplicationForm />
  </main>
</template>

<script setup lang="ts">
  useMetaPixel()
</script>
